import { useContext } from 'react';
import { AuthContext } from './auth.context';
import { AuthState } from './auth.types';
export type { AuthUser } from './auth.types';
export { AuthUserSchema } from './auth.types';
export { AuthProvider } from './auth.provider';
export { ACTIONS } from './auth.actions';

export function useAuth(): AuthState {
  return useContext(AuthContext);
}
